// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8ea9e08b","952":"fa5c2bbb"}[chunkId] + ".chunk.js";
};